export const GET_USER = `user/details`;
export const GET_USER_WITH_ID = {
  USER_ID: id => `user/${id}/details`,
};
export const UPDATE_USER_SECURITY_DATA = `user/update-security-data`;
export const SET_SECURITY_QUESTION_AND_ANSWER = `user/set-user-security`;
export const UPDATE_USER_MEDIA = `user/update-user`;

/**
 * User skills endpoints
 */
export const UPDATE_USER_SKILL = `user/update-skills`;
export const GET_MY_SKILLS = `user/my-skills`;
